import { LEGAL_DOCUMENT_SLUGS, LEGAL_SURFACE_SLUGS } from '../domain/legal';
export const LEGAL_TITLE_KEYS = {
    'kvkk-aydinlatma': 'legal.docTitles.kvkkAydinlatma',
    'gizlilik-politikasi': 'legal.docTitles.gizlilikPolitikasi',
    'kullanim-kosullari': 'legal.docTitles.kullanimKosullari',
    'acik-riza': 'legal.docTitles.acikRiza',
    'cerez-politikasi': 'legal.docTitles.cerezPolitikasi',
    'satis-basvurusu': 'legal.docTitles.satisBasvurusu',
    'kurum-hesabi-aydinlatma': 'legal.docTitles.kurumHesabiAydinlatma',
    'kvkk-basvuru': 'legal.docTitles.kvkkBasvuru',
    'hesap-silme': 'legal.docTitles.hesapSilme',
};
const DOCUMENT_SLUGS = new Set(LEGAL_DOCUMENT_SLUGS);
const SURFACE_SLUGS = new Set(LEGAL_SURFACE_SLUGS);
export function isLegalDocumentSlug(value) {
    return DOCUMENT_SLUGS.has(value);
}
export function isLegalSurfaceSlug(value) {
    return SURFACE_SLUGS.has(value);
}
//# sourceMappingURL=legal-text.js.map